import api from '@/api'
import * as types from '../mutation-types'
import router from '../../router'

// initial state
const state = {
  verificationLoading: false,
  verificationSuccess: false,
  verificationError: false,
  verificationErrorMsg: null,
  nomorPeserta: null
}

// getters
const getters = {
  getVerificationData: state => state
}

// actions
const actions = {
  getVerificationStatus ({ commit, rootState }) {
    api.get('v1/ruang_tes_pendaftar/' + rootState.auth.data.mhs_jalur.nomor_pendaftar)
      .then(response => {
        let responseData = response.data
        if (responseData.success) {
          commit(types.VERIFICATION_SUCCESS, responseData.data.nomor_peserta)
          // router.push({ name: 'KartuUjian' })
        }
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  },
  verifiy ({ commit, dispatch, rootState }) {
    commit(types.VERIFICATION_LOADING)
    api.post('/v2/verifikasi', {
      nomor_pendaftar: rootState.auth.data.mhs_jalur.nomor_pendaftar,
      kode_penawaran: rootState.auth.data.mhs_jalur.kode_penawaran
    })
      .then(response => {
        let responseData = response.data
        if (responseData.success) {
          commit(types.VERIFICATION_LOADING)
          commit(types.VERIFICATION_SUCCESS, responseData.data.nomor_peserta)
          dispatch('getStatusPendaftar', {
            nomorPendaftar: rootState.auth.data.mhs_jalur.nomor_pendaftar,
            kodePenawaran: rootState.auth.data.mhs_jalur.kode_penawaran
          })
          router.push({ name: 'KartuUjian' })
        }
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        commit(types.VERIFICATION_LOADING)
        if (e.response.status === 429) {
          commit(types.VERIFICATION_ERROR, 'Maaf server tidak dapat merespon dengan baik')
        } else if (e.response.status === 403) {
          commit(types.VERIFICATION_ERROR, 'Maaf ruangan penuh, silahkan pilih lokasi/jadwal ujian yang lain. Jika tidak ada yang tersedia, harap menunggu admin menambahkan ruang ujian baru dalam 1x24 jam.')
        } else {
          commit(types.VERIFICATION_ERROR, 'Verifikasi gagal')
        }
        console.log(e)
      })
  },
  closeModal ({ commit }) {
    commit(types.VERIFICATION_CLOSE_MODAL)
  },
  verificationReset ({ commit }) {
    commit(types.VERIFICATION_RESET)
  }
}

// mutations
const mutations = {
  [types.VERIFICATION_LOADING] (state) {
    if (!state.verificationLoading) {
      state.verificationLoading = true
    } else {
      state.verificationLoading = false
    }
  },
  [types.VERIFICATION_SUCCESS] (state, nomorPeserta) {
    state.verificationSuccess = true
    state.verificationError = false
    state.nomorPeserta = nomorPeserta
  },
  [types.VERIFICATION_ERROR] (state, errMsg) {
    state.verificationError = true
    state.verificationSuccess = false
    state.verificationErrorMsg = errMsg
  },
  [types.VERIFICATION_CLOSE_MODAL] (state) {
    state.verificationError = false
    state.verificationErrorMsg = null
  },
  [types.VERIFICATION_RESET] (state) {
    state.verificationLoading = false
    state.verificationSuccess = false
    state.verificationError = false
    state.verificationErrorMsg = null
    state.nomorPeserta = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/verification.js